module.exports = __webpack_public_path__ + "static/media/icon_check_white.94ff5961.svg";